export default "__VITE_ASSET__DcD9706N__"